import InfoDrawer from '../../common/InfoDrawer';
import { Button, DrawerHeader, DrawerBody, Text } from '@chakra-ui/react';
import { useColorModeValue, Grid, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { CustomCsvDownloadIcon } from '../../../theme/icons/CustomCsvDownloadIcon';
import MessageBatchResultDownload from '../messages/MessageBatchResultDownload';
import MoreInfoLine from '../../common/MoreInfoLine';
import PassesBatchesStatus from './BatchesStatus';
import { Badge } from '@chakra-ui/react';

interface BatchUpdateInfo {
  id: string;
  name: string;
  status: string;
  tag?: string | null;
  messageType?: string;
  errorMessage?: string | null;
  errorsCsvUrl?: string | null;
  completedAt?: string | null;
  totalCount?: number;
  errors?: number;
  scheduledAt?: string | null;
}

interface CellData {
  row?: {
    original: BatchUpdateInfo;
  };
  original?: BatchUpdateInfo;
}

interface BatchesUpdateMoreInfoProps {
  isOpen: boolean;
  onClose: () => void;
  cell?: CellData | null;
}

function BatchesUpdateMoreInfo({
  isOpen,
  onClose,
  cell,
}: BatchesUpdateMoreInfoProps) {
  const modeBoxBg = useColorModeValue('white', 'secondaryDark');
  const modeTextBg = useColorModeValue('white', 'primaryDark06');
  const modeLabelBg = useColorModeValue('white', 'primaryDark03');
  const modeBorderColor = useColorModeValue('primaryBackground', 'primaryDark');
  const bgColors = {
    modeBoxBg,
    modeTextBg,
    modeBorderColor,
    modeLabelBg,
  };

  // Support either a react-table cell (cell.row.original) or row (row.original)
  const original: BatchUpdateInfo | null =
    cell?.row?.original ?? cell?.original ?? null;

  return (
    <InfoDrawer
      isOpen={isOpen}
      onClose={onClose}
      header="Batch Update "
      footer={<Button onClick={onClose}>Close</Button>}
      bgColors={bgColors}
    >
      <DrawerHeader>Overview</DrawerHeader>
      <DrawerBody>
        {!original ? (
          <Text>No data available.</Text>
        ) : (
          <>
            <Grid
              templateColumns={{ base: '150px 1fr', md: '192px 1fr' }}
              gap={0}
            >
              <MoreInfoLine heading="Batch Name" value={original.name} />
              <MoreInfoLine heading="Batch ID" value={original.id} />
              {original.tag && (
                <MoreInfoLine
                  heading="Tag"
                  value={
                    original.tag ? (
                      <Badge colorScheme="purple">{original.tag}</Badge>
                    ) : null
                  }
                />
              )}

              <MoreInfoLine
                heading="Status"
                value={<PassesBatchesStatus status={original.status} />}
              />

              <MoreInfoLine heading="Total Count" value={original.totalCount} />
              {original.errors && original.errors > 0 && (
                <MoreInfoLine heading="Total Errors" value={original.errors} />
              )}
              {original.scheduledAt && (
                <MoreInfoLine
                  heading="Scheduled At"
                  value={original.scheduledAt}
                />
              )}
              {original.completedAt && (
                <MoreInfoLine
                  heading="Completed At"
                  value={original.completedAt}
                />
              )}
            </Grid>
          </>
        )}
      </DrawerBody>
    </InfoDrawer>
  );
}

export default BatchesUpdateMoreInfo;
